import { compose, prop } from 'ramda';

import { NAME } from './constants';

const getUserContext = (state) => state[NAME];

export const getCurrentTaskOverviewContext = compose(prop('currentContextUser'), getUserContext);
